import JobTasks from '../../services/jobTasks'
import * as types from "../mutationTypes";

const emptyTask =  { //prevent console errors by passing this to the edit pin dialog when the selected task is null
    taskType: '',
        address: '',
        notes: '',
}
let state = {
    jobTasks: null,
    activeTaskRange: [],
    archivedTaskRange: [],
    delayedTaskRange: [],
    inProgressTaskRange: [],
    selectedJobTask: null,
    jobTaskNumbers: null,
    taskNumbersAndAddress: [],
    error: null,
    activeCount: 0,
    delayedCount: 0,
    inProgressCount: 0,
    archivedCount: 0,
    archivedJobTasks: [],
    delayedJobTasks: [],
    inProgressJobTasks: [],
    completedJobTasks: [],
    mapTaskLocations: [],
    workerMapTaskLocations: [],

    headers: [
        { text: 'Route', value: 'jobTask.routeName' },
        { text: 'Type', value: 'jobTask.taskType' },
        { text: 'Address', value: 'jobTask.displayAddress' },
        { text: 'Notes', value: 'jobTask.notes' },
        { text: 'Scheduled Date', value: 'jobTask.prettyScheduledDate' },
        { text: 'Tags', value: 'jobTask.tagString'},
        { text: 'Actions', value: 'action', sortable: false, width: '10%'}
    ],
    workerHeaders: [
        { text: 'Type', value: 'jobTask.taskType' },
        { text: 'Address', value: 'jobTask.displayAddress' },
        { text: 'Notes', value: 'jobTask.notes' },
        { text: 'Status', value: 'jobTask.displayStatus' },
        { text: 'Actions', value: 'action', sortable: false}
    ]
}
let getters = {
    mapTaskLocations(state) {
        return state.mapTaskLocations
    },
    workerMapTaskLocations(state) {
        return state.workerMapTaskLocations
    },
    activeTaskRange(state) {
        return state.activeTaskRange
    },
    archivedTaskRange(state) {
        return state.archivedTaskRange
    },
    delayedTaskRange(state) {
        return state.delayedTaskRange
    },
    inProgressTaskRange(state) {
        return state.inProgressTaskRange
    },
    overdueTasks(state) {
        let tasks = []
        let d = new Date()
        state.taskNumbersAndAddress.forEach(task => {
            let messageDate = new Date(task.dueDate)
            let dayDiff = Math.ceil((messageDate - d) / (1000 * 60 * 60 * 48))
            if (dayDiff < 0)
                tasks.push({ text: `${task.taskNumber} -- ${task.address}`, value: task.id })
        })
        return tasks
    },
    jobTaskNumbers (state) {
        return state.jobTaskNumbers
    },
    selectedJobTask (state) {
        return state.selectedJobTask
    },
    archivedJobTasks (state) {
        return state.archivedJobTasks
    },
    //If wanted for delayed table
    delayedJobTasks (state) {
        return state.delayedJobTasks
    },
    inProgressJobTasks (state) {
        return state.inProgressJobTasks
    },
    completedJobTasks (state) {
        return state.completedJobTasks
    },
    activeCount (state) {
        return state.activeCount
    },
    archivedCount (state) {
        return state.archivedCount
    },
    delayedCount (state) {
        return state.delayedCount
    },
    inProgressCount (state) {
        return state.inProgressCount
    },
    headers (state) {
        return state.headers
    },
    workerHeaders (state) {
        return state.workerHeaders
    },
    unassignedTasks (state) {
        let tasks = []
        state.taskNumbersAndAddress.forEach(task => {
            tasks.push({ text: `${task.taskNumber} -- ${task.address.slice(0, -12)}`, value: task.id })
        })
        return tasks
    },
    error (state)
    {
        return state.error
    }
}
const mutations = {
    [types.REQUEST_GET_ALL_TASKS_SUCCESS] (state, tasks) {
        state.jobTasks = tasks
        state.error = null
    },
    [types.REQUEST_GET_ALL_TASKS_ERROR] (state, message) {
        state.error = message
        state.jobTasks = [];
        state.archivedJobTasks = [];
    },
    [types.REQUEST_GET_MAP_TASK_LOCATIONS_SUCCESS] (state, locs) {
        state.mapTaskLocations = locs
        state.error = null
    },
    [types.REQUEST_GET_MAP_TASK_LOCATIONS_ERROR] (state, message) {
        state.error = message
        state.mapTaskLocations = [];
    },
    [types.REQUEST_GET_WORKER_MAP_TASK_LOCATIONS_SUCCESS] (state, locs) {
        state.workerMapTaskLocations = locs
        state.error = null
    },
    [types.REQUEST_GET_WORKER_MAP_TASK_LOCATIONS_ERROR] (state, message) {
        state.error = message
        state.workerMapTaskLocations = [];
    },
    [types.REQUEST_GET_ACTIVE_TASK_RANGE_SUCCESS] (state, tasks) {
        state.activeTaskRange = tasks
        state.error = null
    },
    [types.REQUEST_GET_ACTIVE_TASK_RANGE_ERROR] (state, message) {
        state.activeTaskRange = null
        state.error = message
    },
    [types.REQUEST_GET_DELAYED_TASK_RANGE_SUCCESS] (state, tasks) {
        state.delayedTaskRange = tasks
        state.error = null
    },
    [types.REQUEST_GET_DELAYED_TASK_RANGE_ERROR] (state, message) {
        state.delayedTaskRange = null
        state.error = message
    },
    [types.REQUEST_GET_IN_PROGRESS_TASK_RANGE_SUCCESS] (state, tasks) {
        state.inProgressTaskRange = tasks
        state.error = null
    },
    [types.REQUEST_GET_IN_PROGRESS_TASK_RANGE_ERROR] (state, message) {
        state.inProgressTaskRange = null
        state.error = message
    },
    [types.REQUEST_GET_ARCHIVED_TASK_RANGE_SUCCESS] (state, tasks) {
        state.archivedTaskRange = tasks
        state.error = null
    },
    [types.REQUEST_GET_ARCHIVED_TASK_RANGE_ERROR] (state, message) {
        state.error = message
        state.archivedTaskRange = [];
    },
    [types.REQUEST_GET_ARCHIVED_TASKS_SUCCESS] (state, tasks) {
        state.archivedJobTasks = tasks
        state.error = null
    },
    [types.REQUEST_GET_ARCHIVED_TASKS_ERROR] (state, message) {
        state.error = message
        state.archivedJobTasks = [];
    },
    [types.REQUEST_GET_DELAYED_TASKS_SUCCESS] (state, tasks) {
        state.delayedJobTasks = tasks
        state.error = null
    },
    [types.REQUEST_GET_DELAYED_TASKS_ERROR] (state, message) {
        state.error = message
        state.delayedJobTasks = [];
    },
    [types.REQUEST_GET_IN_PROGRESS_TASKS_SUCCESS] (state, tasks) {
        state.inProgressJobTasks = tasks
        state.error = null
    },
    [types.REQUEST_GET_IN_PROGRESS_TASKS_ERROR] (state, message) {
        state.error = message
        state.inProgressJobTasks = [];
    },
    [types.REQUEST_GET_COMPLETED_TASKS_SUCCESS] (state, tasks) {
        state.error = null
        state.completedJobTasks = tasks;
    },
    [types.REQUEST_GET_COMPLETED_TASKS_ERROR] (state, message) {
        state.error = message
        state.completedJobTasks = [];
    },
    [types.REQUEST_GET_TASK_BY_ID_SUCCESS] (state, task) {
        state.selectedJobTask = task
        state.error = null
    },
    [types.REQUEST_GET_TASK_BY_ID_ERROR] (state, message) {
        state.error = message
        state.selectedJobTask = null
    },
    [types.REQUEST_UPDATE_TASK_SUCCESS] (state, task) {
        state.selectedJobTask = task
        state.error = null
    },
    [types.REQUEST_UPDATE_TASK_ERROR] (state, message) {
        state.error = message
        state.selectedJobTask = null
    },
    [types.REQUEST_DELETE_TASK_SUCCESS] (state, task) {
        state.selectedJobTask = task
        state.error = null
    },
    [types.REQUEST_DELETE_TASK_ERROR] (state, message) {
        state.error = message
        state.selectedJobTask  = null
    },
    [types.REQUEST_CREATE_TASK_SUCCESS] (state, task) {
        state.selectedJobTask  = task
        state.error = null
    },
    [types.REQUEST_CREATE_TASK_ERROR] (state, message) {
        state.error = message
        state.selectedJobTask  = null
    },
    [types.REQUEST_COMPLETE_TASK_SUCCESS] (state, task) {
        state.selectedJobTask  = task
        state.error = null
    },
    [types.REQUEST_COMPLETE_TASK_ERROR] (state, message) {
        state.error = message
        state.selectedJobTask  = null
    },
    [types.REQUEST_ARCHIVE_TASK_SUCCESS] (state, task) {
        state.selectedJobTask = task
        state.error = null
    },
    [types.REQUEST_ARCHIVE_TASK_ERROR] (state, message) {
        state.error = message
        state.selectedJobTask = null
    },
    [types.REQUEST_RESTORE_TASK_SUCCESS] (state, task) {
        state.selectedJobTask = task
        state.error = null
    },
    [types.REQUEST_RESTORE_TASK_ERROR] (state, message) {
        state.error = message
        state.selectedJobTask = null
    },
    [types.REQUEST_GET_TASK_NUMBER_SUCCESS] (state, taskNumbers) {
        state.jobTaskNumbers = taskNumbers
        state.error = null
    },
    [types.REQUEST_GET_TASK_NUMBER_ERROR] (state, message) {
        state.error = message
        state.jobTaskNumbers = null
    },
    [types.CLEAR_SELECTED_TASK] (state) {
      state.selectedJobTask = emptyTask
    },
    [types.REQUEST_GET_ACTIVE_TASK_COUNT] (state, count) {
        state.activeCount = count
    },
    [types.REQUEST_GET_ARCHIVED_TASK_COUNT] (state, count) {
        state.archivedCount = count
    },
    [types.REQUEST_GET_DELAYED_TASK_COUNT] (state, count) {
        state.delayedCount = count
    },
    [types.REQUEST_GET_IN_PROGRESS_TASK_COUNT] (state, count) {
        state.inProgressCount = count
    },
    [types.REQUEST_TASK_NUMBER_ADDRESS_SUCCESS] (state, tasks) {
        state.taskNumbersAndAddress = tasks
        state.error = null
    },
    [types.REQUEST_TASK_NUMBER_ADDRESS_ERROR] (state, message) {
        state.taskNumbersAndAddress = null
        state.error = message
    },
    [types.ASSIGN_TASK] (state) {
        state.error = null
    },
}
const actions = {
    async clearSelected({ commit }) {
        commit(types.CLEAR_SELECTED_TASK)
    },
    async select({ commit }, task) {
        commit(types.REQUEST_GET_TASK_BY_ID_SUCCESS, task)
    },
    async getAll ({ commit }) {
        try {
            let res = await JobTasks.get()
            if (res) {
                commit(types.REQUEST_GET_ALL_TASKS_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_ALL_TASKS_ERROR, error.message)
        }
    },
    async getNumberAndAddress({ commit }) {
        try {
            let res = await JobTasks.getTaskNumberAndAddress()
            if (res) {
                commit(types.REQUEST_TASK_NUMBER_ADDRESS_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_TASK_NUMBER_ADDRESS_ERROR, error.message)
        }
    },
    async getMapTaskLocations ({ commit }, dateRange) {
        if(!dateRange)
            return
        const nextYear = new Date()
        nextYear.setFullYear(nextYear.getFullYear() + 1)
        const startDate = dateRange.startDate ? dateRange.startDate : '1970-01-01'
        const endDate = dateRange.endDate ? dateRange.endDate : nextYear.toISOString().slice(0, 10)
        try {
            let res = await JobTasks.getMapTaskLocations(startDate, endDate)
            if (res) {
                commit(types.REQUEST_GET_MAP_TASK_LOCATIONS_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_MAP_TASK_LOCATIONS_ERROR, error.message)
        }
    },
    async getWorkerMapTaskLocations ({ commit }) {
        try {
            let res = await JobTasks.getWorkerMapTaskLocations()
            if (res) {
                commit(types.REQUEST_GET_WORKER_MAP_TASK_LOCATIONS_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_WORKER_MAP_TASK_LOCATIONS_ERROR, error.message)
        }
    },
    async getActiveRange ({ commit }, rangeRequest) {
        const keywords = rangeRequest.keywords
        const limit = rangeRequest.limit
        const offset = rangeRequest.offset
        const startDate = rangeRequest.startDate ? rangeRequest.startDate : '1970-01-01'
        const nextYear = new Date()
        nextYear.setFullYear(nextYear.getFullYear() + 1)
        const endDate = rangeRequest.endDate ? rangeRequest.endDate : nextYear.toISOString().slice(0, 10)
        try {
            let res = await JobTasks.getActiveRange(keywords, limit, offset, startDate, endDate)
            if (res) {
                commit(types.REQUEST_GET_ACTIVE_TASK_RANGE_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_ACTIVE_TASK_RANGE_ERROR, error.message)
        }
    },
    async getDelayedRange ({ commit }, rangeRequest) {
        const keywords = rangeRequest.keywords
        const limit = rangeRequest.limit
        const offset = rangeRequest.offset
        try {
            let res = await JobTasks.getDelayedRange(keywords, limit, offset)
            if (res) {
                commit(types.REQUEST_GET_DELAYED_TASK_RANGE_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_DELAYED_TASK_RANGE_ERROR, error.message)
        }
    },
    async getInProgressRange ({ commit }, rangeRequest) {
        const keywords = rangeRequest.keywords
        const limit = rangeRequest.limit
        const offset = rangeRequest.offset
        try {
            let res = await JobTasks.getInProgressRange(keywords, limit, offset)
            if (res) {
                commit(types.REQUEST_GET_IN_PROGRESS_TASK_RANGE_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_IN_PROGRESS_TASK_RANGE_ERROR, error.message)
        }
    },
    async getArchivedRange ({ commit }, rangeRequest) {
        const keywords = rangeRequest.keywords
        const limit = rangeRequest.limit
        const offset = rangeRequest.offset
        try {
            let res = await JobTasks.getArchivedRange(keywords, limit, offset)
            if (res) {
                commit(types.REQUEST_GET_ARCHIVED_TASK_RANGE_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_ARCHIVED_TASK_RANGE_ERROR, error.message)
        }
    },
    async getArchived({ commit }) {
        try {
            let res = await JobTasks.getArchived()
            if (res) {
                commit(types.REQUEST_GET_ARCHIVED_TASKS_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_ARCHIVED_TASKS_ERROR, error.message)
        }
    },
    async getDelayed({ commit }) {
        try {
            let res = await JobTasks.getDelayed()
            if (res) {
                commit(types.REQUEST_GET_DELAYED_TASKS_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_DELAYED_TASKS_ERROR, error.message)
        }
    },
    async getInProgress({ commit }) {
        try {
            let res = await JobTasks.getInProgress()
            if (res) {
                commit(types.REQUEST_GET_IN_PROGRESS_TASKS_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_IN_PROGRESS_TASKS_ERROR, error.message)
        }
    },
    async getCompleted ({ commit }) {
        try {
            let res = await JobTasks.getCompleted()
            if (res) {
                commit(types.REQUEST_GET_COMPLETED_TASKS_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_COMPLETED_TASKS_ERROR, error.message)
        }
    },
    async getById ({ commit }, id) {
        try {
            let res = await JobTasks.getById(id)
            if (res) {
                commit(types.REQUEST_GET_TASK_BY_ID_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_TASK_BY_ID_ERROR, error.message)
        }
    },
    async getTaskNumbers({ commit }) {
      let res = await JobTasks.getTaskNumbers()
      try {
          if (res) {
              commit(types.REQUEST_GET_TASK_NUMBER_SUCCESS, res.data)
          }
      } catch (error) {
          commit(types.REQUEST_GET_TASK_NUMBER_ERROR, error.message)
      }
    },
    async getActiveCount ({ commit }) {
        const res = await JobTasks.getActiveCount()
        commit(types.REQUEST_GET_ACTIVE_TASK_COUNT, res.data)
    },
    async getArchivedCount ({ commit }) {
        const res = await JobTasks.getArchivedCount()
        commit(types.REQUEST_GET_ARCHIVED_TASK_COUNT, res.data)
    },
    async getDelayedCount ({ commit }) {
        const res = await JobTasks.getDelayedCount()
        commit(types.REQUEST_GET_DELAYED_TASK_COUNT, res.data)
    },
    async getInProgressCount ({ commit }) {
        const res = await JobTasks.getInProgressCount()
        commit(types.REQUEST_GET_IN_PROGRESS_TASK_COUNT, res.data)
    },
    async delete ({ commit, dispatch }, id) {
        try {
            let res = await JobTasks.delete(id)
            if (res) {
                commit(types.REQUEST_DELETE_TASK_SUCCESS, res.data)
                dispatch('getArchived')
            }
        } catch (error) {
            commit(types.REQUEST_DELETE_TASK_ERROR, error.message)
        }
    },
    async create ({ commit, dispatch }, taskToCreate) {
        try {
            let res = await JobTasks.create(taskToCreate)
            if (res) {
                await commit(types.REQUEST_CREATE_TASK_SUCCESS, res.data)
                dispatch('getMapTaskLocations')
                //dispatch('getDelayed')
                dispatch('routes/getAll', {}, { root: true })
            }
        } catch (error) {
            commit(types.REQUEST_CREATE_TASK_ERROR, error.message)
        }
    },
    async update ({ commit, dispatch }, taskToUpdate) {
        try {
            if (Array.isArray(taskToUpdate)) {
                for (const task of taskToUpdate) {
                    let res = await JobTasks.update(task)
                    if (res) {
                        commit(types.REQUEST_UPDATE_TASK_SUCCESS, res.data)
                    }
                }
            } else {
                let res = await JobTasks.update(taskToUpdate)
                if (res) {
                    commit(types.REQUEST_UPDATE_TASK_SUCCESS, res.data)
                }
            }
            dispatch('getMapTaskLocations')
            dispatch('getWorkerMapTaskLocations')
            dispatch('getCompleted')
            dispatch('getTaskNumbers')
            dispatch('getNumberAndAddress')
            dispatch('routes/getAll', {}, { root: true })
            dispatch('tags/getAll', {}, { root: true })
        } catch (error) {
            commit(types.REQUEST_UPDATE_TASK_ERROR, error.message)
        }
    },
    async assignTask ({ commit, dispatch }, request) {
        await JobTasks.assignTask(request.taskId, request.routeId)
        dispatch('getNumberAndAddress')
        commit(types.ASSIGN_TASK)
    },
    async archiveGroup({ commit ,dispatch}, idList) {
        try {
            let res = await JobTasks.archiveGroup(idList)
            if (res) {
                commit(types.REQUEST_ARCHIVE_TASK_SUCCESS, res.data)
                dispatch('getCompleted')
                dispatch('getNumberAndAddress')
            }
        } catch (error) {
            commit(types.REQUEST_ARCHIVE_TASK_ERROR, error.message)
        }
    },
    async archive ({ commit, dispatch}, id) {
        try {
            let res = await JobTasks.archive(id)
            if (res) {
                commit(types.REQUEST_ARCHIVE_TASK_SUCCESS, res.data)
                dispatch('getCompleted')
                dispatch('getTaskNumbers')
            }
        } catch (error) {
            commit(types.REQUEST_ARCHIVE_TASK_ERROR, error.message)
        }
    },
    async complete ({ commit, dispatch}, id) {
        try {
            let res = await JobTasks.complete(id)
            if (res) {
                commit(types.REQUEST_COMPLETE_TASK_SUCCESS, res.data)
                dispatch('routes/getAll', {}, { root: true })
                dispatch('getTaskNumbers')
            }
        } catch (error) {
            commit(types.REQUEST_COMPLETE_TASK_ERROR, error.message)
        }
    },
    async restore ({ commit, dispatch }, id) {
        try {
            let res = await JobTasks.restore(id)
            if (res) {
                commit(types.REQUEST_RESTORE_TASK_SUCCESS, res.data)
                dispatch('getDelayed')
            }
        } catch (error) {
            commit(types.REQUEST_RESTORE_TASK_ERROR, error.message)
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
